<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">
    Convênio
  </div>
  <div class="flex justify-center gap-2 align-center">
    <button class="btn-icon" (click)="uploadList()">
      <mat-icon>replay</mat-icon>
    </button>
  @if (checkPermission('criar')) {
    <div class="mr-8">
      <button mat-raised-button class="btn-add" (click)="newEmployee()">
        Novo
      </button>
    </div>
  }
  </div>
</div>

<div>
  <div class="mt-4">
    <div class="mb-3 flex flex-col w-full items-center gap-4">
      <div class="w-full ga-4 flex justify-center align-start">
        <form [formGroup]="form" class="flex justify-center ga-4 align-start">
          <mat-form-field class="input-tg px-2" appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" (selectionChange)="onChange()">
              @for (municipio of [{id: 1, nome: "Ativo"}, {id: 2, nome: "Inativo"}]; track municipio.id) {
                <mat-option [value]="municipio.id">{{ municipio.nome }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    </div>
    <div>
      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editItem($event)"
            (deleteItem)="deleteItem($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
